import { render, staticRenderFns } from "./BlockedPage.vue?vue&type=template&id=4dc72dd3&scoped=true"
import script from "./BlockedPage.vue?vue&type=script&lang=js"
export * from "./BlockedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc72dd3",
  null
  
)

export default component.exports